import React from 'react';
import { CandidateProvider } from './CandidateFormProvider';
import { Navigation } from './components/Navigation/Navigation';
import { Content } from './components/Content/Content';
import { HeaderContainer, Wrapper } from './CandidateForm.styles';
import { ReactComponent as CandidateSvg } from 'App/assets/img/candidate.svg';
import { useParams } from 'react-router-dom';
import HeaderPage from 'App/Components/HeaderPage';

enum ModeScreen {
	Insert = 'new',
	Update = 'update',
	Display = 'display',
}

type ParamsProps = { mode: ModeScreen; id: string };

export const CandidateForm = () => {
	const { mode } = useParams() as ParamsProps;

	const getTitleText = () => {
		return mode === ModeScreen.Update
			? 'Editar candidatos'
			: 'Añadir candidatos';
	};

	return (
		<CandidateProvider>
			<HeaderContainer>
				<HeaderPage
					svgIcon={<CandidateSvg className="icon-add-candidate" />}
					title={getTitleText()}
					buttons={[]}
				/>
			</HeaderContainer>
			<Wrapper>
				<Navigation />
				<Content />
			</Wrapper>
		</CandidateProvider>
	);
};
